var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero is-medium is-fullheight is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }